import { Injectable } from '@angular/core';
import { Response, RequestOptions } from "@angular/http";

import { Router } from "@angular/router";
import { Observable } from 'rxjs';

import "rxjs/Rx";

import { Subject } from "rxjs/Subject";

import { iResponseInfo } from '../../../interfaces/shared/iResponseInfo';
import { AuthHttp } from "angular2-jwt";
import { environment } from "../../../../environments/environment";
import { VehicleInfoService } from './vehicle-info.service';
@Injectable()
export class VehicleService {
  constructor(private authHttp: AuthHttp, private router: Router, private vehicleInfoService: VehicleInfoService) { }

  vehicleSearchResultsChanged = new Subject();
  vehicleSearchResultsCleared = new Subject();
  vehicleSelected = new Subject<any>();
  vehicleGettingInfo = new Subject();

  private errorMessage: string = null;
  hasErrors() {
    return this.errorMessage != null;
  }
  getErrorMessage() {
    return this.hasErrors() ? this.errorMessage : "";
  }

  private vehicleSearchResults: any;

  private responseInfo: iResponseInfo = new iResponseInfo();

  getById(registrationId: number, appUserId: number) {
    this.performSearch(registrationId, "", "", "", "", appUserId);
  }

  search(plateNumber, referenceNumber, provinceId, vin, appUserId) {
    this.performSearch(0, referenceNumber, plateNumber, provinceId, vin, appUserId);
  }

  private performSearch(registrationId, referenceNumber, plateNumber, provinceId, vin, appUserId) {
    this.vehicleGettingInfo.next(true);
    this.errorMessage = null;
    this.vehicleSearchResults = null;

    let postObj = {
      'registrationId': registrationId,
      'referenceNumber': referenceNumber,
      'plateNumber': plateNumber,
      'provinceId': provinceId,
      'vin': vin,
      'languageId': 1,
      'appUserId': appUserId
    };

    var qs = environment.apiPath + '/api/enforcement/VehicleSearch';

    return this.authHttp.post(qs, postObj)
      .map(
        (response: Response) => {
          return response.json();
        }).subscribe(
          (response: any) => {
            this.responseInfo = new iResponseInfo();

            this.vehicleSearchResults = response;
            console.log("vehicle search results are changed");

            this.responseInfo.isSuccess = response.responseInfo.isSuccess;
            this.responseInfo.isWarning = response.responseInfo.isWarning;
            this.responseInfo.isError = response.responseInfo.isError;
            this.responseInfo.message = response.responseInfo.message;

            this.vehicleSearchResultsChanged.next();
            this.vehicleGettingInfo.next(false);
          },
          (error) => {
            this.errorMessage = error;
            this.vehicleSearchResultsChanged.next();
            this.vehicleGettingInfo.next(false);
          });
  }

  clearSearchResult() {
    this.responseInfo = new iResponseInfo();
    this.vehicleSearchResults = null;
    this.vehicleSearchResultsCleared.next();
    this.vehicleGettingInfo.next(false);
  }

  getResponseInfo() {
    return this.vehicleSearchResults == null ? new iResponseInfo() : this.responseInfo;
  }

  hasResults() {
    return this.vehicleSearchResults != null;
  }

  getVehicleSearchResultList() {
    return this.vehicleSearchResults == null ? null : this.vehicleSearchResults.list.slice();
  }

  private selectedVehicle: any;

  vehiclePreview(vehicle: any) {
    this.selectedVehicle = vehicle;

    this.router.navigate(['/search/owners']);

    this.vehicleSelected.next(vehicle);
  }

  getVehicle() {
    if (this.hasResults) {
      return this.vehicleSearchResults.list[0];
    }

    return null;
  }

  private handleErrorPromise(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }

  private handleErrorObservable(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.message || error);
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/nonanon/vehicle/vehicle.service.ts